import React from "react";
import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { Dashboard, Description, FavoriteBorder, Home, MeetingRoom } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logoutUser } from "../../redux/Actions/authActions";

const AusbildungNavbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return (
    <AppBar position="static" sx={{ bgcolor: "white", color: "#202124", boxShadow: "0 2px 10px rgba(0,0,0,.06)" }}>
      <Toolbar sx={{ gap: 2, px: { xs: 2, md: 4 } }}>
        <Typography variant="h6" fontWeight={900} sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center", cursor: "pointer" }} onClick={() => navigate("/dashboard?view=ausbildung_manager")}>
          <Dashboard /> AUSBILDUNG PANEL
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button color="inherit" startIcon={<Description />} onClick={() => navigate("/dashboard/ausbildung/submissions")}>Applications</Button>
          <Button color="inherit" startIcon={<FavoriteBorder />} onClick={() => navigate("/dashboard/ausbildung/interests")}>Interests</Button>
          <Button color="inherit" startIcon={<MeetingRoom />} onClick={() => navigate("/dashboard/ausbildung/rooms")}>Rooms</Button>
          <Button color="inherit" startIcon={<Home />} onClick={() => navigate("/")}>Home</Button>
          <Button color="error" onClick={() => dispatch(logoutUser(false))}>Logout</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default AusbildungNavbar;
